import { createSlice } from "@reduxjs/toolkit";

const ITServicesSlice = createSlice({
  name: "ITServices",
  initialState: {
    LMS: {
      data: [],
      loading: false,
      error: null,
    },

    studentPortal: {
      data: [],
      loading: false,
      error: null,
    },
    office: {
      data: [],
      loading: false,
      error: null,
    },
    onlinePayment: {
      data: [],
      loading: false,
      error: null,
    },

    passwordManager: {
      data: [],
      loading: false,
      error: null,
    },

    helpDesk: {
      data: [],
      loading: false,
      error: null,
    },

    IMS: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {

    fetchIMSStart(state) {
      state.IMS.loading = true;
      state.IMS.error = null;
    },
    fetchIMSSuccess(state, action) {
      state.IMS.loading = false;
      state.IMS.data = action.payload;
    },
    fetchIMSFailure(state, action) {
      state.IMS.loading = false;
      state.IMS.error = action.payload;
    },
    updateIMSStart(state) {
      state.LMS.loading = true;
      state.IMS.error = null;
    },
    updateIMSSuccess(state, action) {
      state.IMS.loading = false;
      state.IMS.data = action.payload;
    },
    updateIMSFailure(state, action) {
      state.IMS.loading = false;
      state.IMS.error = action.payload;
    },


    fetchLMSStart(state) {
      state.LMS.loading = true;
      state.LMS.error = null;
    },
    fetchLMSSuccess(state, action) {
      state.LMS.loading = false;
      state.LMS.data = action.payload;
    },
    fetchLMSFailure(state, action) {
      state.LMS.loading = false;
      state.LMS.error = action.payload;
    },
    updateLMSStart(state) {
      state.LMS.loading = true;
      state.LMS.error = null;
    },
    updateLMSSuccess(state, action) {
      state.LMS.loading = false;
      state.LMS.data = action.payload;
    },
    updateLMSFailure(state, action) {
      state.LMS.loading = false;
      state.LMS.error = action.payload;
    },

    fetchStudentPortalStart(state) {
      state.studentPortal.loading = true;
      state.studentPortal.error = null;
    },
    fetchStudentPortalSuccess(state, action) {
      state.studentPortal.loading = false;
      state.studentPortal.data = action.payload;
    },
    fetchStudentPortalFailure(state, action) {
      state.studentPortal.loading = false;
      state.studentPortal.error = action.payload;
    },
    updateStudentPortalStart(state) {
      state.studentPortal.loading = true;
      state.studentPortal.error = null;
    },
    updateStudentPortalSuccess(state, action) {
      state.studentPortal.loading = false;
      state.studentPortal.data = action.payload;
    },
    updateStudentPortalFailure(state, action) {
      state.studentPortal.loading = false;
      state.studentPortal.error = action.payload;
    },

    fetchOfficeStart(state) {
      state.office.loading = true;
      state.office.error = null;
    },
    fetchOfficeSuccess(state, action) {
      state.office.loading = false;
      state.office.data = action.payload;
    },
    fetchOfficeFailure(state, action) {
      state.office.loading = false;
      state.office.error = action.payload;
    },
    updateOfficeStart(state) {
      state.office.loading = true;
      state.office.error = null;
    },
    updateOfficeSuccess(state, action) {
      state.office.loading = false;
      state.office.data = action.payload;
    },
    updateOfficeFailure(state, action) {
      state.office.loading = false;
      state.office.error = action.payload;
    },

    fetchOnlinePaymentStart(state) {
      state.onlinePayment.loading = true;
      state.onlinePayment.error = null;
    },
    fetchOnlinePaymentSuccess(state, action) {
      state.onlinePayment.loading = false;
      state.onlinePayment.data = action.payload;
    },
    fetchOnlinePaymentFailure(state, action) {
      state.onlinePayment.loading = false;
      state.onlinePayment.error = action.payload;
    },
    updateOnlinePaymentStart(state) {
      state.onlinePayment.loading = true;
      state.onlinePayment.error = null;
    },
    updateOnlinePaymentSuccess(state, action) {
      state.onlinePayment.loading = false;
      state.onlinePayment.data = action.payload;
    },
    updateOnlinePaymentFailure(state, action) {
      state.onlinePayment.loading = false;
      state.onlinePayment.error = action.payload;
    },

    fetchPasswordManagerStart(state) {
      state.passwordManager.loading = true;
      state.passwordManager.error = null;
    },
    fetchPasswordManagerSuccess(state, action) {
      state.passwordManager.loading = false;
      state.passwordManager.data = action.payload;
    },
    fetchPasswordManagerFailure(state, action) {
      state.passwordManager.loading = false;
      state.passwordManager.error = action.payload;
    },
    updatePasswordManagerStart(state) {
      state.passwordManager.loading = true;
      state.passwordManager.error = null;
    },
    updatePasswordManagerSuccess(state, action) {
      state.passwordManager.loading = false;
      state.passwordManager.data = action.payload;
    },
    updatePasswordManagerFailure(state, action) {
      state.passwordManager.loading = false;
      state.passwordManager.error = action.payload;
    },

    fetchHelpDeskStart(state) {
      state.helpDesk.loading = true;
      state.helpDesk.error = null;
    },
    fetchHelpDeskSuccess(state, action) {
      state.helpDesk.loading = false;
      state.helpDesk.data = action.payload;
    },
    fetchHelpDeskFailure(state, action) {
      state.helpDesk.loading = false;
      state.helpDesk.error = action.payload;
    },
    updateHelpDeskStart(state) {
      state.helpDesk.loading = true;
      state.helpDesk.error = null;
    },
    updateHelpDeskSuccess(state) {
      // The update API only returns an ack message (no help desk record),
      // so keep the existing data intact. The component re-fetches fresh
      // data right after, which repopulates the form (auto-fetch on edit).
      state.helpDesk.loading = false;
    },
    updateHelpDeskFailure(state, action) {
      state.helpDesk.loading = false;
      state.helpDesk.error = action.payload;
    },
  },
});
export const {
  fetchLMSStart,
  fetchLMSSuccess,
  fetchLMSFailure,
  updateLMSStart,
  updateLMSSuccess,
  updateLMSFailure,
  fetchStudentPortalStart,
  fetchStudentPortalSuccess,
  fetchStudentPortalFailure,
  updateStudentPortalStart,
  updateStudentPortalSuccess,
  updateStudentPortalFailure,
  fetchOfficeStart,
  fetchOfficeSuccess,
  fetchOfficeFailure,
  updateOfficeStart,
  updateOfficeSuccess,
  updateOfficeFailure,
  fetchOnlinePaymentStart,
  fetchOnlinePaymentSuccess,
  fetchOnlinePaymentFailure,
  updateOnlinePaymentStart,
  updateOnlinePaymentSuccess,
  updateOnlinePaymentFailure,
  fetchPasswordManagerStart,
  fetchPasswordManagerSuccess,
  fetchPasswordManagerFailure,
  updatePasswordManagerStart,
  updatePasswordManagerSuccess,
  updatePasswordManagerFailure,
  fetchHelpDeskStart,
  fetchHelpDeskSuccess,
  fetchHelpDeskFailure,
  updateHelpDeskStart,
  updateHelpDeskSuccess,
  updateHelpDeskFailure,
  fetchIMSStart,
fetchIMSSuccess,
fetchIMSFailure,
updateIMSStart,
updateIMSSuccess,
updateIMSFailure
} = ITServicesSlice.actions;

export default ITServicesSlice.reducer;
